
import { getFaultList } from '@/api/other';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import GroupFault from '@/views/groups/components/GroupFault.vue';

@Component({
  name: 'faultDialog',
  components: {
    GroupFault,
  },
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  faultVisible!: Boolean;

   @Prop({
     default: '1'
   })
  faultType!: string;

  private selectedFault = {
        id: 0,
        name: '',
        type: '',
      };

  created() {

  }

  close() {
    this.$emit('close', false);
  }
  checkedFaultChange(selectFault:any){
    if(selectFault && selectFault.length > 0){
      const  element= selectFault[0];
      this.selectedFault = {
        id: element.id,
        name: element.name,
        type: this.faultType
      }
    }
  }
  confirmFault() {
    if (!this.selectedFault || (this.selectedFault && this.selectedFault.id === 0)) {
      this.$notify({
        title: '提示',
        message: '请选择故障类型',
        duration: 3000,
        offset: 100,
        type: 'error'
      });
      return false;
    }
    this.$emit('selectresult',this.selectedFault );
    this.close();
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
